

import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { listadoTodasNotas } from "../../../services";







export const useNotasIngresoTodas = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');
    const termino = searchParams.get('termino') || '';

    const { data, isLoading } = useQuery({
        queryKey: ['todo-notas', { page, termino }], 
        queryFn: () => listadoTodasNotas({ page, termino }),
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageTermino = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('termino', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    return {
        // Estados
        page,
        termino,
        // Métodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
